import { ObjectState } from '../../../shared/utils/object-state';

export class DeleteRequestAnswer {
  objectState: ObjectState;
  objectIsBeingUsedBy: string[];

  constructor(objectState: ObjectState, objectIsBeingUsedBy: string[]) {
    this.objectState = objectState;
    this.objectIsBeingUsedBy = objectIsBeingUsedBy;
  }
}
